import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import "./JobSubCategory.css"
import JobSubCategoryService from "../../admin/Shared/Services/JobSubCategoryService";
import { errorMessages, getMaxLengthErrorMessage, getRequiredErrorMessage, jobSubCategoryNameMaxLength, jobCategoryActivityNamePattern } from "../Shared/Constants/AdminModuleConstants";
import SweetAlertService from "../../../services/SweetAlertService";

export const UpdateJobSubCategory = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();

    const [jobCategoryList, setJobCategoryList] = useState([]);
    const [categoryId, setCategoryId] = useState();

    useEffect(() => {
        getJobSubCategoryById();
    }, []);

    const getJobSubCategoryById = () => {
        JobSubCategoryService.getJobSubCategoryById(Number(id)).then((response: any) => {
            setJobCategoryList(response.data.jobCategoryDtos);
            setValue("name", response.data.name);
            //setValue("isDefaultInWorkActivity", response.data.isDefaultInWorkActivity.toString());
            setCategoryId(response.data.jobCategoryId);
            setTimeout(() => {
                setValue("jobCategoryId", response.data.jobCategoryId);
            }, 25);
        }).catch(() => {
            SweetAlertService.error("Error", `Something went wrong while getting job sub category by id ${id}`);
        })
    }

    const onSubmit = (data: any) => {
        data.name = data.name.trim();
        //data.isDefaultInWorkActivity = data.isDefaultInWorkActivity == 'true';
        data.isSystemDefined = true;
        data.id = id;
        JobSubCategoryService.updateJobSubCategory(Number(id), data).then((response) => {
            if (response) {
                reset();
                navigate('/jobsubcategory/' + data.jobCategoryId);
            }
        }).catch(error => {
            SweetAlertService.error("Error", error.response.data.errors.Name[0])
        })
    };
    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Edit Job sub category</h4>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group row">
                        <label className="col-sm-3 control-label">Job Category</label>
                        <div className="col-sm-9">
                            <select className="form-select"
                                {...register("jobCategoryId", { required: getRequiredErrorMessage("Job Category"), })}>
                                <option value="">Please select Job category</option>
                                if (jobCategoryList.length)
                                {
                                    jobCategoryList.map((e: any) => (
                                        <option value={e.id} key={e.id}>{e.name}</option>
                                    ))
                                }
                            </select>
                            {errors.jobCategoryId && (
                                <span className="help-block m-b-none text-danger field-validation-valid">{errors.jobCategoryId.message?.toString()}</span>
                            )}
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <label className="col-sm-3 control-label">Name</label>
                        <div className="col-sm-9">
                            <input
                                type="text"
                                className="form-control"
                                {...register("name", {
                                    required: getRequiredErrorMessage("Name"),
                                    maxLength: {
                                        value: jobSubCategoryNameMaxLength,
                                        message: getMaxLengthErrorMessage(jobSubCategoryNameMaxLength)
                                    },
                                    pattern: {
                                        value: jobCategoryActivityNamePattern,
                                        message: errorMessages.pattern
                                    },
                                })}
                            />
                            {errors.name && (
                                <span className="help-block m-b-none text-danger field-validation-valid">{errors.name.message?.toString()}</span>
                            )}
                        </div>
                    </div>
                    <br />
                    {/*<div className="form-group row">*/}
                    {/*    <label className="col-sm-3 control-label">Is Default In WorkActivity</label>*/}
                    {/*    <div className="col-sm-9">*/}
                    {/*        <div className="d-flex flex-row">*/}
                    {/*            <input*/}
                    {/*                value="true"*/}
                    {/*                type="radio"*/}
                    {/*                {...register("isDefaultInWorkActivity")}*/}
                    {/*            />Yes*/}
                    {/*            <input className="ms-3"*/}
                    {/*                value="false"*/}
                    {/*                type="radio"*/}
                    {/*                {...register("isDefaultInWorkActivity")}*/}
                    {/*            />No*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<br />*/}
                    <div className="form-group row">
                        <div className=" col-sm-offset-3">
                            <a className="btn btn-secondary"
                                onClick={() => navigate('/jobsubcategory/' + categoryId)}>
                                Cancel
                            </a>
                            <button className="btn btn-primary ms-1"
                                type="submit">
                                Update
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}